import React, { Fragment } from 'react';
import ColorConstants from '../../constants/ColorConstants';

const defaultProps = {
    platform: '',
};

const AccordionLabel = ({ platform }) => (
    <Fragment>
        {`${platform.replace('_', ' ')}`}
        <div color={ColorConstants['pastel-green']} />
    </Fragment>
);

AccordionLabel.defaultProps = defaultProps;

export default AccordionLabel;
